import ShowerCommon from "../showerNew/showerCommon";
import store from "../../../../../store";
import {IS_QKB_UI} from "../../../../../config";
import {createParentPositions, ShowerHeadTypes} from "../../../../look/core/constants";
import {METADATA} from "../../constants";
import {applyFeatureToLayerPosition} from "../../../../look/lookNavigation/lookFunctions";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import {ShowerAccessories} from "../../parts/showerAccessories";

export default class ShowerArm extends ShowerCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'shower_arm';
    this.partName = 'Shower Arm';
    this.translateId = "visualizer.bathroom.accessories.shower_arm";
    this.canBeDisabled = true;
    this.layerPriority = 8;
    // this.useMatchingFeatureReplacement = "MountPosition";
    if (isChild) {
      this.useMathingByName = true;
      createParentPositions(this);
    }
  }

  navigationSubItems(...props) {
    if (IS_QKB_UI) {
      return this.navigationSubItemsWithSides(...props)
    }
    return super.navigationSubItems(...props);
  }

  load(dbFeature) {
    if (!dbFeature.metaData["Side"] || (Array.isArray(dbFeature.metaData["Side"]) && dbFeature.metaData["Side"][0] === "0")) {
      dbFeature.metaData["Side"] = [METADATA.LeftSide];
    }
    if (dbFeature.filterValueIDs?.["10"]) {
      dbFeature.metaData["MatchingColor"] = dbFeature.filterValueIDs["10"];
    }
    return super.loadAsBV6(dbFeature)
  }

  handleClick(ignoreLocked) {
    this.setArmHeadType();
    super.handleClick(ignoreLocked);
    if (this.notAvailableInVisualizer || getFeatureIsLocked(this)) {
      return
    }
    const layout = this.getParent().getParent().layout;
    if (layout.parts[ShowerAccessories.id]?.handleShowerValve) {
      layout.parts[ShowerAccessories.id].handleShowerValve.checkValveMountType(this);
    }
  }

  checkForSameMountPosition(newFeature) {
    if (newFeature.metaData["MountPosition"] || newFeature.metaData["MountType"]) {
      let conditions = [];
      if (newFeature.metaData["MountPosition"]) {
        conditions.push({
          propName: "MountPosition",
          propValue: newFeature.metaData["MountPosition"]
        });
      }
      if (newFeature.metaData["MountType"]) {
        conditions.push({
          propName: "MountType",
          propValue: newFeature.metaData["MountType"]
        });
      }
      if (newFeature.metaData["MatchingColor"]) {
        conditions.push({
          propName: "MatchingColor",
          propValue: newFeature.metaData["MatchingColor"]
        });
      }
      Object.keys(this.layerPositions).forEach(position => {
        if ((position !== newFeature.metaData.layerPosition) && this.layerPositions[position]
          && !this.layerPositions[position].matchesMetaForArrayOfConditions(conditions)) {
          this.layerPositions[position] = null; // erase current position
        }
      })
    }
  }

  getActiveFeatureConditions(feature) {
    const conditions = this.getArrayOfConditions();
    if (feature?.metaData["MatchingColor"]) {
      conditions.push({
        propName: "MatchingColor",
        propValue: feature.metaData["MatchingColor"]
      });
    }
    return conditions
  }

  applyFeatureIfNotCompatible() {
    const showerParent = this.getParent().getParent();
    if (showerParent.showerFixture) {
      showerParent.showerFixture.disabled = true;
    }
  }

  disabledClick() {
    if (!this.disabled && this.activeFeature && Object.keys(this.layerPositions).every(position => {
      return !this.layerPositions[position];
    })) {
      applyFeatureToLayerPosition(this.activeFeature); // apply it on position
    }
    const showerHead = this.getParent().showerHead;
    if (showerHead) {
      showerHead.disabled = this.disabled || !showerHead.canBeEnabled(); // true or check if it can be enabled;
      if (showerHead.disabled && showerHead.layerPositions) {
        Object.keys(showerHead.layerPositions).forEach(position => {
          showerHead.layerPositions[position] = null;
        })
      }
    }
    if (!this.disabled && this.activeFeature) {
      const layout = this.getParent().layout;
      if (layout.parts[ShowerAccessories.id]?.handleShowerValve) {
        layout.parts[ShowerAccessories.id].handleShowerValve.checkValveMountType(this);
      }
    }
  }

  hideLayerCondition() {
    const showerParent = this.getParent();
    return showerParent.shower_head_type !== ShowerHeadTypes.shower_arm && this.activeFeature
  }

  setLayers(layout) {
    const showerParent = this.getParent();
    if (this.hideLayerCondition()) {
      super.hideLayers();
      return;
    }
    if (showerParent.showerHead && showerParent.showerHead.layerPositions && this.layerPositions && this.activeFeature) {
      Object.keys(showerParent.showerHead.layerPositions).forEach(position => {
        if (!this.layerPositions[position] && showerParent.showerHead.layerPositions[position]) {
          this.layerPositions[position] = this.getMatchingPositionFeature(position)
        } else if (this.layerPositions[position] && !showerParent.showerHead.layerPositions[position]) {
          const {wizardActiveItem} = store.getState().wizardState;
          if (!wizardActiveItem || !wizardActiveItem.hideItems) {
            this.layerPositions[position] = null
          }
        }
      })
    }
    return super.setLayers(layout);
  }

  setZIndex(zIndexes) {
    if (zIndexes) {
      Object.keys(this.layerPositions).forEach((key, keyIndex) => {
        if (this.layerPositions[key]) {
          this.layerPositions[key].layer.zIndex = zIndexes.Shower.ShowerArm + keyIndex*10;
        }
      })
    }
  }

}
